export interface QuestionsProps { }

export interface IOptionurl {
  option_url: File;
  optionurlname: File;
  optionurlstatus: boolean;
  id: number | null;

}
export interface IOption {
  optionname: string;
  optionstatus: boolean;
  id: number | null;
}
export interface IQuestions {

  id?: number;
  page?: number;
  page_size?: number;
  prompt?: string | null;
  questionType?: number | null;
  subType?: number | null;
  grouped_question?: number | null;
  question_url?: File | null;
  prompt_url?: File | null;
  question?: string | null;
  instruction?: string | null;
  explanation?: string | null;
  // difficulty_level?: string | null;
  yeargroup_region?: number[];
  source_type?: string | null;
  option_type?: string | null;
  main?: boolean;
  answer?: boolean;
  Status?: boolean;
  free_tier?: boolean;
  option_url?: IOptionurl[];
  option?: IOption[];
  options?: IOption[]; // Update to an array of IOption objects
  imgWidth?: number;
  promptImgWidth?: number;
  answer_type?: string;
  drag_drop_pattern?: string;
  drag_drop_data?: IDragDropItem[];
}

export enum AnswerType {
  MCQ = "MCQ",
  // TRUE_FALSE = "TRUE_FALSE",
  DRAG_DROP = "DRAG_DROP",
  // TABLE = "TABLE",
  // FILL_BLANK = "FILL_BLANK",
}

export enum DragDropPattern {
  ITEMS_TO_BUCKETS = "items_to_buckets",
  BUCKETS_TO_ITEMS = "buckets_to_items",
}

export interface IDragDropItem {
  item_text: string;
  target_bucket: string;
  id?: number | null;
  item_url?: string | null;
}



export interface IQuestionsData {
  pagination: IPagination;
  questions: IQuestion[];
}

export interface IPagination {
  total_count: number;
  total_pages: number;
  current_page: number;
  page_size: number;
  current_count: number;
}

export interface IQuestion {
  id: number;
  questionType: number | null;
  Question_type_name?: string | null;

  subType: number | null;
  subType_name?: string | null;

  question: string | null;
  question_url: string | null;

  Status: boolean;
  prompt: string | null;
  instruction: string | null;
  explanation: string | null;
  prompt_url?: File | null;

  main: boolean;
  free_tier: boolean;

  grouped_question: number | null;
  source_type: string | null;

  time: string;

  options: IOption[];

  state: "active" | "inactive";
  yeargroup_region: number[];
}
